import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        color: "secondary",
        classes: "custom-text-input",
      },
    },
  },
  palette: {
    primary: {
      main: "rgb(18, 18, 18)",
    },
    secondary: {
      main: "rgba(252, 163, 17, 1)",
    },
    common: {
      grey: "rgb(128, 128, 128)",
      green: "rgb(3, 226, 107)",
      white: "rgb(255, 255, 255)",
      yellow: "rgb(252, 163, 17)",
    },
  },
  typography: {
    h1: {
      color: "rgb(255, 255, 255)",
      fontSize: "40px",
      fontWeight: 400,
      lineHeight: "1.1em",
      fontFamily: "'Outfit', sans-serif",
    },
    h5: {
      color: "#005589",
      textTransform: "capitalize",
      fontSize: "22px",
      fontWeight: 450,
    },
    h6: {
      color: "#F58344",
      textTransform: "uppercase",
      fontSize: "16px",
    },
    h3: {
      fontSize: "1.75em",
    },
    body1: {
      color: "#080809",
      lineHeight: "30px",
    },
    body2: {
      color: "#A9A9A9",
      fontSize: "13px",
      fontWeight: 500,
    },
  },
});

export default theme;
